import React, { useRef, useEffect, useState } from 'react';
import { createChart, ColorType } from 'lightweight-charts';
import { Form } from 'react-bootstrap';
import {useLaravelReactI18n} from "laravel-react-i18n";
export const ChartComponent = (props) => {
    const {t} = useLaravelReactI18n();
    const { series, colors: {
        backgroundColor = 'white',
        textColor = 'black',
        fatherColor = '#293bff',
        motherColor = '#ffcd29',
        balanceColor = '#66ff29'
    } = {} } = props;

    const chartContainerRef = useRef();
    const [showFather, setShowFather] = useState(true);
    const [showMother, setShowMother] = useState(true);
    const [showBalance, setShowBalance] = useState(true);

    useEffect(() => {
        const handleResize = () => {
            chart.applyOptions({ width: chartContainerRef.current.clientWidth });
        };

        const chart = createChart(chartContainerRef.current, {
            layout: {
                background: { type: ColorType.Solid, color: backgroundColor },
                textColor,
            },
            width: chartContainerRef.current.clientWidth,
            height: 400,
        });

        chart.timeScale().fitContent();

        let fatherSeries, motherSeries, balanceSeries;

        if (showFather) {
            fatherSeries = chart.addLineSeries({ color: fatherColor });
            fatherSeries.setData(series.father);
        }

        if (showMother) {
            motherSeries = chart.addLineSeries({ color: motherColor });
            motherSeries.setData(series.mother);
        }

        if (showBalance) {
            balanceSeries = chart.addBaselineSeries({
                baseValue: { type: 'price', price: 0 },
                topLineColor: 'rgba( 38, 166, 154, 1)',
                topFillColor1: 'rgba( 38, 166, 154, 0.28)',
                topFillColor2: 'rgba( 38, 166, 154, 0.05)',
                bottomLineColor: 'rgba( 239, 83, 80, 1)',
                bottomFillColor1: 'rgba( 239, 83, 80, 0.05)',
                bottomFillColor2: 'rgba( 239, 83, 80, 0.28)'
            });
            balanceSeries.setData(series.balance);
            const zeroPriceLine = {
                price: 0,
                color: '#3179F5',
                lineWidth: 2,
                lineStyle: 2, // LineStyle.Dashed
                axisLabelVisible: true,
                title: '0€',
            };
            balanceSeries.createPriceLine(zeroPriceLine);
        }


        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
            chart.remove();
        };
    }, [series, backgroundColor, textColor, fatherColor, motherColor, balanceColor, showFather, showMother, showBalance]);

    return (
        <div>
            <div className="d-flex justify-content-around mb-2">
                <Form.Check
                    type="switch"
                    id="switch-father"
                    label={t('Father')}
                    checked={showFather}
                    onChange={(e) => setShowFather(e.target.checked)}
                />
                <Form.Check
                    type="switch"
                    id="switch-mother"
                    label={t('Mother')}
                    checked={showMother}
                    onChange={(e) => setShowMother(e.target.checked)}
                />
                <Form.Check
                    type="switch"
                    id="switch-balance"
                    label={t("Balance")}
                    checked={showBalance}
                    onChange={(e) => setShowBalance(e.target.checked)}
                />
            </div>

            <div className="h-100" ref={chartContainerRef} />
        </div>
    );
};
